import { Component, Input, OnInit } from '@angular/core';
import { UpdateSelectedProcedure } from '../../../store/actions/selected-procedure.actions';
import { select, Store } from '@ngrx/store';
import { environment } from '../../../../../../environments/environment';
import { SaveCustomerMission } from '../../../store/actions/customer-mission.actions';
import { FileService } from '../../../services/file.service';
import { NotReceivedPaymentInterface } from '../../../models/not-received-payment.interface';
import { ConstsHelper } from '../../../../../helpers/consts.helper';
import moment from 'moment';
import { PaymentsPaginatorInterface } from '../../../../payments/models/payments.paginator.interface';
import { PaymentsInterfaceState } from '../../../../payments/store/state/payments.state';
import { UpdatePaginator } from '../../../store/actions/paginator.actions';
import { GetPayments } from '../../../../payments/store/actions/payments.actions';
import { PaginatorInterface } from '../../../models/paginator.interface';
import { PaymentInterface } from '../../../../payments/models/payment.interface';
import * as FileSaver from 'file-saver';
import { PaymentsService } from '../../../../payments/services/payments.service';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'app-not-received-payment',
  templateUrl: './not-received-payment.component.html',
  styleUrls: ['./not-received-payment.component.css'],
  standalone: false
})
export class NotReceivedPaymentComponent implements OnInit {

  @Input()
  step: number;

  amount: number = null;
  date: string = null;
  checkNumber: string = null;
  sumbitLock: boolean;
  formSubmittedOnce = false;
  file = File;
  fileNameDisplay: string;
  constsHelper = ConstsHelper;
  payments: PaymentsPaginatorInterface;
  comment: string;
  notConformFormGroup: FormGroup;
  currentSelectedPage: number;
  totalItemsPerPage: number = 5;
  brand?: string;

  errors: any = {
    type: {
      required: `Le moyen de paiement est obligatoire.`,
    },
    checkNumber: {
      required: `Le numéro de chèque est obligatoire.`,
      pattern: `Le numéro de chèque est invalide.`,
    },
    date: {
      required: `La date est obligatoire.`,
      matDatepickerFilter: `La date est invalide.`,
    },
    amount: {
      required: `Le montant est obligatoire.`,
      pattern: `Le montant est invalide.`,
    },
    file: {
      required: `Le fichier est obligatoire.`,
    }
  };

  constructor(
    private store: Store<any>,
    private fileService: FileService,
    private paymentsService: PaymentsService,
    private formBuilder: FormBuilder,
    private matIconRegistry: MatIconRegistry,
    private domSanitizer: DomSanitizer
  ) {
  }

  ngOnInit() {
    this.store.pipe(select(ConstsHelper.REDUCER_PAYMENTS)).subscribe((response: PaymentsInterfaceState) => {
      if (response.payments) {
        this.payments = response.payments;
        this.store.dispatch(new UpdatePaginator(this.getPaginator(null)));
      }
    });

    this.brand = environment.data.brand;
    this.currentSelectedPage = 1;
    this.store.dispatch(new GetPayments(this.currentSelectedPage, this.totalItemsPerPage));
    this.initForm();
    this.matIconRegistry.addSvgIcon(
      'agenda',
      this.domSanitizer.bypassSecurityTrustResourceUrl(
        '../../../../../../../assets/images/icons/' + this.brand + '_small-agenda.svg'
      )
    );
    this.sumbitLock = false;
  }

  dateRangeFilter = (forDay: Date | null): boolean => {
    return moment(forDay).isBefore(moment(new Date())) && moment(forDay).isAfter((moment(new Date()).subtract(180, 'd')));
  }

  getFile($event) {
    this.file = $event.target.files.item(0);
    if ($event.target.files.item(0)) {
      this.fileNameDisplay = $event.target.files.item(0).name;
    } else {
      this.fileNameDisplay = null;
    }
  }

  confirmation() {
    this.formSubmittedOnce = true;
    if (!this.sumbitLock) {
      this.sumbitLock = true;
      const notReceivedPayment = {
        date: moment(this.notConformFormGroup.controls.date.value).format('YYYY-MM-DD'),
        amount: this.notConformFormGroup.controls.amount.value,
        checkNumber: this.notConformFormGroup.controls.checkNumber.value,
        type: this.notConformFormGroup.controls.type.value,
        step: 1,
        comment: this.notConformFormGroup.controls.comment.value,
        fileId: null,
      } as unknown as NotReceivedPaymentInterface;

      if (this.notConformFormGroup.valid) {
        if (this.fileNameDisplay) {
          this.fileService.create(this.file, this.fileNameDisplay, environment.data.supportingDocumentsFileTypeSlug, environment.data.supportingDocumentsBucketSlug).subscribe(response => {
            notReceivedPayment.fileId = response.fileId;
            this.store.dispatch(new SaveCustomerMission(notReceivedPayment, this.constsHelper.PROCEDURE_NOT_RECEIVED_PAYMENT, 'payment'));
          });
        }
      } else {
        this.sumbitLock = false;
      }
    }
  }

  getCreditFile(payment: PaymentInterface) {
    this.paymentsService.downloadCreditFile(payment.id, payment.file.replace('/home/_services_/pxl_files/', '')).subscribe(
      (file: Blob) => {
        FileSaver.saveAs(new Blob([file], {type: 'application/pdf'}), payment.file.replace('/home/_services_/pxl_files/', ''));
      }
    );
  }

  private getPaginator(type?: string) {
    return {
      currentSelectedPage: this.payments.currentPage,
      selectedLine: null,
      action: GetPayments,
      totalItems: this.payments.totalItems,
      type,
    } as PaginatorInterface;
  }

  decimalComma(price: number): string {
    return Math.abs(parseFloat(price.toString())).toFixed(2).replace(/\./g, ',');
  }

  cancel() {
    this.store.dispatch(new UpdateSelectedProcedure(''));
  }

  private initForm() {
    this.notConformFormGroup = this.formBuilder.group({});
    this.notConformFormGroup.addControl('date', new FormControl('', [Validators.required]));
    this.notConformFormGroup.addControl('amount', new FormControl('', [Validators.required]));
    this.notConformFormGroup.addControl('checkNumber', new FormControl('', [Validators.required, Validators.pattern('[0-9]{9}')]));
    this.notConformFormGroup.addControl('type', new FormControl('', [Validators.required]));
    this.notConformFormGroup.addControl('file', new FormControl('', [Validators.required]));
    this.notConformFormGroup.addControl('comment', new FormControl('', []));
  }

  getError(formControlName: string): string {
    let errorMsg = '';
    Object.keys(this.notConformFormGroup.controls[formControlName].errors).map(
      key => {
        errorMsg = this.errors[formControlName][key];
      }
    );
    return errorMsg;
  }

  hasError(formControlName: string): boolean {
    return this.notConformFormGroup.controls[formControlName].invalid &&
      (this.notConformFormGroup.controls[formControlName].touched || this.formSubmittedOnce);
  }


  setValidator() {
    if (this.notConformFormGroup.controls.type.value === 'check') {
      this.notConformFormGroup.controls.checkNumber.setValidators([Validators.required]);
      this.notConformFormGroup.controls.checkNumber.updateValueAndValidity();
    } else {
      this.notConformFormGroup.controls.checkNumber.clearValidators();
      this.notConformFormGroup.controls.checkNumber.updateValueAndValidity();
    }
  }
}
